import React, { Component } from 'react'
import './Navbar.sass'
import Logo from './Logo'
import { NavLink } from 'react-router-dom'
import ACL from '@components/ACL'
import PropTypes from 'prop-types'

import { observer, inject } from 'mobx-react'

import Button from '@components/Button'
import DashboardIcon from '@components/Icon/Dashboard'
import ExpertsIcon from '@components/Icon/Experts'
import ProjectsIcon from '@components/Icon/ProjectsIcon'
import MyProjectsIcon from '@components/Icon/MyProjects'
import FullProfileIcon from '@components/Icon/FullProfile'
import ReportsIcon from '@components/Icon/Reports'
import ClientRecordsIcon from '@components/Icon/ClientRecords'
import AdminIcon from '@components/Icon/Admin'
import SupportIcon from '@components/Icon/Support'
import SherlockIcon from '@components/Icon/Sherlock'
import SubNav from '@components/SubNav'
import { List } from '@material-ui/icons'

class Navbar extends Component {
  static propTypes = {
    customClass: PropTypes.string,
    activeProjectStore: PropTypes.object
  }

  render() {
    const {
      activeProjectId,
      activeProjectName,
      isActiveProjectLocked,
      resetLock
    } = this.props.activeProjectStore

    const classNameProjects = activeProjectId
      ? ' Navbar__item__dropdown__projects'
      : ''

    return (
      <div className={`Navbar ${this.props.customClass ?? ''}`}>
        <NavLink to={'/dashboard'}>
          <Logo />
        </NavLink>

        <NavLink
          to={'/dashboard'}
          className="Navbar__item"
          activeClassName="Navbar__item--active">
          <DashboardIcon />
          <SubNav title="Dashboard" />
        </NavLink>

        <NavLink
          to={'/project-management'}
          className="Navbar__item"
          activeClassName="Navbar__item--active">
          <MyProjectsIcon />
          <SubNav title="Project Management">
            <NavLink to="/client-projects">Client Pending Projects</NavLink>
          </SubNav>
        </NavLink>

        <NavLink
          to={'/project-search'}
          className="Navbar__item"
          activeClassName="Navbar__item--active">
          <ProjectsIcon />
          <SubNav
            title="Projects"
            className={'Navbar__item__dropdown' + classNameProjects}>
            {activeProjectId ? (
              <div>
                <NavLink to={`/project/${activeProjectId}`}>
                  Active: <b>{activeProjectName}</b>
                </NavLink>
                {isActiveProjectLocked ? (
                  <Button
                    className="active-project-reset-button"
                    onClick={e => {
                      e.preventDefault()
                      e.stopPropagation()
                      resetLock()
                    }}>
                    Reset
                  </Button>
                ) : null}
              </div>
            ) : null}
            <NavLink to="/my-projects">My Projects</NavLink>
          </SubNav>
        </NavLink>

        <NavLink
          to={'/expert-search'}
          className="Navbar__item"
          activeClassName="Navbar__item--active">
          <ExpertsIcon />
          <SubNav title="Experts" />
        </NavLink>

        <ACL
          roles={[
            'FeeManagement',
            'Accounting',
            'AdvancedExpertManagement',
            'ProjectManagement',
            'AdvancedReporting',
            'Admin'
          ]}>
          <div className="Navbar__item">
            <ClientRecordsIcon />
            <SubNav title="Client records">
              <NavLink to="/client-search">Clients records</NavLink>
              <NavLink to="/client-contact-search">Client contacts</NavLink>
              <NavLink to="/contract-search">Contracts</NavLink>
            </SubNav>
          </div>
        </ACL>

        <NavLink
          to={'/list'}
          className="Navbar__item"
          activeClassName="Navbar__item--active">
          <List style={{ color: 'white', opacity: 0.6 }} />
          <SubNav title="Lists" />
        </NavLink>

        <div className="Navbar__item">
          <ReportsIcon className="Navbar--icon" />
          <SubNav title="Reports">
            <ACL
              roles={[
                'FeeManagement',
                'Accounting',
                'AdvancedExpertManagement',
                'ProjectManagement',
                'AdvancedReporting',
                'Admin'
              ]}>
              <ACL
                roles={[
                  'FeeManagement',
                  'Accounting',
                  'AdvancedExpertManagement',
                  'AdvancedReporting',
                  'Admin'
                ]}>
                <NavLink to={'/reports/expert-payments'}>
                  Expert payments
                </NavLink>
              </ACL>
              <ACL roles={['ProjectManagement']}>
                <NavLink to={'/reports/projects-pipeline'}>
                  Project pipeline
                </NavLink>
              </ACL>
              <NavLink to={'/reports/created-invoices'}>
                Created invoices
              </NavLink>
              <NavLink to={'/reports/drafted-invoices'}>
                Drafted invoices
              </NavLink>
              <NavLink to={'/reports/revenues'}>Revenues</NavLink>
              <NavLink to={'/reports/general-fees'}>General fees</NavLink>
              <ACL roles={['Accounting', 'Admin']}>
                <NavLink to={'/reports/financial-revenue'}>
                  Financial revenue
                </NavLink>
                <NavLink to={'/reports/payments'}>Payments</NavLink>
              </ACL>
            </ACL>
            <NavLink to={'/reports/performance'}>Performance</NavLink>
            <NavLink to={'/reports/currency-rates'}>Currency Rates</NavLink>
          </SubNav>
        </div>

        <ACL roles={['Admin', 'HR', 'TeamManagment', 'OPSManagment']}>
          <div className="Navbar__item">
            <AdminIcon />
            <SubNav title="Admin">
              <ACL roles={['Admin', 'OPSManagment']}>
                <NavLink to={'/admin/atheneum-office'}>
                  Atheneum companies
                </NavLink>
              </ACL>
              <ACL roles={['Admin']}>
                <NavLink to={'/admin/compliance'}>Compliance language</NavLink>
              </ACL>
              <ACL roles={['Admin', 'OPSManagment']}>
                <NavLink to={'/admin/contractual-details'}>
                  Contractual details
                </NavLink>
              </ACL>
              <ACL roles={['Admin']}>
                <NavLink to={'/admin/department-responsible-users'}>
                  Department responsible users
                </NavLink>
              </ACL>
              <ACL roles={['Admin', 'HR', 'TeamManagment']}>
                <NavLink to={'/employee-search'}>Employees</NavLink>
              </ACL>
              <ACL roles={['Admin']}>
                <NavLink to={'/admin/epd-rejection-reason'}>
                  ERM email templates
                </NavLink>
                <NavLink to={'/log'}>Events log</NavLink>
                <NavLink to={'/admin/email-templates'}>Email templates</NavLink>
              </ACL>
              <ACL roles={['Admin', 'TeamManagment']}>
                <NavLink to={'/admin/teams'}>Teams</NavLink>
              </ACL>
              <ACL roles={['Admin', 'OPSManagment']}>
                <NavLink to={'/admin/units-of-work'}>Units of work</NavLink>
              </ACL>
              <ACL roles={['Admin', 'Accounting']}>
                <NavLink to={'/admin/booking-stop'}>Booking stop</NavLink>
              </ACL>
              <ACL roles={['Admin']}>
                <NavLink to="/admin/deployment-announcement">
                  Announce deployment
                </NavLink>
              </ACL>
              <ACL roles={['Admin']}>
                <NavLink to="/admin/elastic-reindex">Reindex elastic</NavLink>
              </ACL>
            </SubNav>
          </div>
        </ACL>

        <ACL roles={['Admin', 'OPSManagment', 'AdvancedExpertManagement']}>
          <NavLink
            to={'/compliance-breach'}
            className="Navbar__item"
            activeClassName="Navbar__item--active">
            <SherlockIcon />
            <SubNav title="Compliance Breach" />
          </NavLink>
        </ACL>

        <div className="Navbar__item">
          <SupportIcon />
          <SubNav title="Support">
            <a href="https://atheneum-partners.atlassian.net/wiki/spaces/AA/pages/85360644/Training+Slides+New+Platform+Interface+2018">
              Platform academy
            </a>
            <a href="https://atheneum-partners.atlassian.net/servicedesk/customer/portal/8">
              Create platform ticket
            </a>
          </SubNav>
        </div>

        {/* show only in development */}
        {process.env.NODE_ENV === 'development' && (
          <NavLink to={'/icons'} activeClassName="active" className="dev-link">
            <FullProfileIcon />
          </NavLink>
        )}
      </div>
    )
  }
}

export default inject('activeProjectStore')(observer(Navbar))
